import { warehouses } from 'constants/warehouses';

import { useAppSelector } from 'redux/hooks';
import { RootState } from 'redux/store';

import { Icon } from 'components/Icon';
import { Sticker } from 'components/Sticker';
import { StickerSize } from 'components/Sticker/Sticker.styles';

import * as S from './Qty.styles';

interface Props {
  qty: number;
  size?: StickerSize;
}

export const QtySticker: React.FC<Props> = ({ qty, size }) => {
  const { warehouse } = useAppSelector((state: RootState) => state.settings);
  const isSimpleCatalogue = warehouse.code === warehouses[0].code;

  return (
    <S.QtyWrapper>
      {isSimpleCatalogue ? (
        <Sticker color="greenSecondary" size={size}>
          <Icon name="FiArrowUp" />
        </Sticker>
      ) : (
        <Sticker color="greenSecondary" size={size}>
          {qty.toString()}
        </Sticker>
      )}
    </S.QtyWrapper>
  );
};
